import React from 'react';
import PropTypes from 'prop-types';
import {
  FDAlert,
  FDBodyText,
  FDList,
  FDListItem,
  FDListItemIcon,
  FDListItemText,
  FDStack,
} from '@facet-wealth/design';
import { useListDetailViewContext } from 'Components/ComponentLibrary/Organisms/ListDetailView/Context';

export default function List({
  collection,
}) {
  const {
    selectedResourceId,
    setSelectedResourceId,
    listLoading,
  } = useListDetailViewContext();

  if (!collection) {
    return null;
  }

  return (
    <FDStack direction={'column'}>
      <FDStack direction={'row'} minHeight={'20px'} paddingX={2} justifyContent={'center'} alignItems={'center'}>
        {listLoading && <FDBodyText size={'sm'} color={'textDisabled'} value={'Loading...'} />}
      </FDStack>
      <FDList>
        {collection.resources().length() > 0
          ? collection.resources().list().map((el) => (
            <FDListItem
              key={el.id()}
              onClick={() => {
                // Do not allow switching when the list is refreshing
                if (listLoading) {
                  return;
                }
                setSelectedResourceId(el.id());
              }}
              selected={el.id() === selectedResourceId}
              inset
            >
              <FDListItemIcon icon={el.attr('icon') || 'circleOutline'} color={el.attr('iconColor') || 'primary'} />
              <FDListItemText primaryText={el.attr('title')} secondaryText={el.attr('description')} />
            </FDListItem>
          )) : (
            <FDAlert status="warning" title="No Results" />
          )}
      </FDList>
    </FDStack>
  );
}

List.propTypes = {
  collection: PropTypes.object.isRequired,
};

List.defaultProps = {
};
